export const insertTable = "Insert a Table";
export const deleteTable = "Delete a Table";
export const addColumnBefore = "Add A Column Before";
export const addColumnAfter = "Add a Column After";
export const deleteColumn = "Delete a Column";
export const addRowBefore = "Add a Row Before";
export const addRowAfter = "Add a Row After";
export const deleteRow = "Delete a Row";
export const mergeCells = "Merge Cells";
export const splitCells = "Split Cells";
export const toggleHeaderColumn = "Toggle Header Column";
export const toggleHeaderRow = "Toggle Header Row";
export const toggleHeaderCell = "Toggle Header Cell";
export const mergeOrSplit = "Merge or Split Cells";
export const setCellAttribute = "Set Cell Attribute";
export const fixTables = "Fix Tables";
export const goToNextCell = "Go To Next Cell";
export const goToPreviousCell = "Go To Previous Cell";
